/**
 * Main Layout Component
 * RiskMetrica Views - Board Risk Committee Control Centre
 *
 * Application shell wrapper with Header, Sidebar, and content area
 */

import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ArbiterPanel } from './ArbiterPanel';
import { useNavigationStore } from '@/stores/navigationStore';
import { useSessionStore } from '@/stores/sessionStore';
import { useArbiterStore } from '@/stores/arbiterStore';

export function MainLayout() {
  const { sidebarOpen } = useNavigationStore();
  const { theme } = useSessionStore();
  const { panelOpen } = useArbiterStore();

  // Apply theme to document root
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      {/* Fixed Header */}
      <Header />

      {/* Fixed Sidebar */}
      <Sidebar />

      {/* Arbiter Panel */}
      <ArbiterPanel />

      {/* Main Content Area */}
      <main
        className="transition-all duration-200"
        style={{
          marginTop: 'var(--header-height)',
          marginLeft: sidebarOpen ? 'var(--sidebar-width)' : '64px',
          marginRight: panelOpen ? '400px' : '0',
          minHeight: 'calc(100vh - var(--header-height))',
        }}
      >
        {/* Content Container with Padding */}
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
